(function () {
  const initDetails = (root) => {
    if (!root || root.dataset.detailsReady === 'true') return;
    root.dataset.detailsReady = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-details-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-details-panel]'));
    if (!tabs.length || !panels.length) return;

    const select = (tab) => {
      const id = tab.getAttribute('data-details-tab');
      tabs.forEach((item) => {
        const on = item === tab;
        item.classList.toggle('is-active', on);
        item.setAttribute('aria-selected', on ? 'true' : 'false');
        item.tabIndex = on ? 0 : -1;
      });
      panels.forEach((panel) => {
        const on = panel.getAttribute('data-details-panel') === id;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
      const stage = root.querySelector('.rebx-product-details__stage');
      if (stage) stage.scrollTop = 0;
    };

    const specItems = Array.from(
      root.querySelectorAll('.rebx-product-details__panel--specs li, .rebx-spec-list li')
    );
    specItems.forEach((item) => {
      if (item.querySelector('.rebx-product-details__spec-label') || !item.isConnected) return;
      const text = (item.textContent || '').trim();
      const splitAt = text.indexOf(':');
      if (splitAt < 1) return;
      const label = text.slice(0, splitAt).trim();
      let value = text.slice(splitAt + 1).trim();
      if (label && !value) {
        const next = item.nextElementSibling;
        if (next && next.tagName === 'LI' && !(next.textContent || '').includes(':')) {
          value = (next.textContent || '').trim();
          next.remove();
        }
      }
      if (!label || !value) return;
      item.classList.add('rebx-product-details__spec');
      item.replaceChildren();
      const labelEl = document.createElement('span');
      labelEl.className = 'rebx-product-details__spec-label';
      labelEl.textContent = label;
      const valueEl = document.createElement('span');
      valueEl.className = 'rebx-product-details__spec-value';
      valueEl.textContent = value;
      item.append(labelEl, valueEl);
    });

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') {
          return;
        }
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        tabs[next].focus();
        select(tabs[next]);
      });
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-rebx-product-details]').forEach(initDetails);
  };

  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
